export default "__VITE_ASSET__CsfnMcQi__";